<template>
    <CardPage :section="20" :page="7" :nextFunction="finish" :audio="true">
        <p>
            You’ve earned your final trophy, a shield, because you know how to protect yourself! You’ve made your Mother very proud!
        </p>
        <ResponsiveImage :src="trophy.image" :alt="trophy.text" flex="xs6"></ResponsiveImage>
        <p>
            Remember:<br />
            Protecting yourself: I deserve it! I can have it! And I know how to get it!
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        trophy: get('section20/trophy')
    },
    methods: {
        finish() {
            this.$store.set('section20/trophy@earned', true);
        }
    }
};
</script>
